import get from "lodash/get";
import sortBy from "lodash/sortBy";

import {AuditGroup} from "@/pages/pagespeed/report/body/AuditGroup.tsx";
import {AuditScoreBadge} from "@/pages/pagespeed/report/body/AuditScoreBadge.tsx";
import {PagespeedLHR, PSReportCategories} from "@/pages/pagespeed/types.ts";

import {filterAuditRefs, prepareAuditData} from "../legacyHelpers";

interface CategoryGroupProps {
  title: string;
  name: string;
  className?: string;
  categories: PSReportCategories;
  lhr: PagespeedLHR;
}
export const CategoryGroup = ({lhr, className, title, name, categories}: CategoryGroupProps) => {
  const category = get(categories, name);
  if (!category) {
    return null;
  }

  const audits = filterAuditRefs(category.auditRefs ?? [])
    .map((audit) => prepareAuditData(lhr, audit.id))
    // hide audits that we don't want to show with score == 1
    .filter((audit) => audit.score !== 1)
    // hide audits with score null and no details
    .filter((audit) => !(audit.score === null && !audit.details));
  // sort audits by score showing audits with null score at the end
  const sortedAudits = sortBy(audits, (audit) => (audit.score === null ? 2 : audit.score));

  return (
    <div className={className}>
      <h5>
        <span className="me-2">
          {title} - {(category.score * 100).toFixed(0)}%
        </span>
        <AuditScoreBadge audit={{score: category.score}} />
      </h5>
      <AuditGroup title="" audits={sortedAudits} />
    </div>
  );
};
